import { SearcherNameToId } from "../../../../../../helpers/common/searchers/constants.js";
export const multisearcherPropsToSearcherTabsProps = (rootProps)=>{
    const { name , className , componentClass , data , props  } = rootProps || {};
    const { tabs =[]  } = props ?? data ?? {};
    return {
        name,
        className,
        componentClass,
        props: {
            items: tabs.map((tab)=>{
                const searcherName = tab.data.name ?? tab.data?.ajaxComponentData?.Name;
                const commonProps = {
                    title: tab.title,
                    id: searcherName ? SearcherNameToId[searcherName] : '',
                    redirect: false
                };
                if (tab.data?.ajaxComponentData) {
                    return {
                        ...commonProps,
                        ajaxComponentData: tab.data?.ajaxComponentData
                    };
                }
                return {
                    ...commonProps,
                    searcher: tab.data?.data ?? tab.data?.props
                };
            }).filter((tab)=>!!tab.id)
        }
    };
};

//# sourceMappingURL=converter.js.map